<template>
  <component
    :is="tag"
    :href="href || undefined"
    :class="classes"
    :disabled="disabled"
    class="mdc-button"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <div class="mdc-button__ripple"></div>
    <am-icon :icon="leadingIcon" v-if="leadingIcon" class="mdc-button__icon" />
    <span class="mdc-button__label">
      <!-- @slot Button label -->
      <slot />
    </span>
    <am-icon :icon="trailingIcon" v-if="trailingIcon" class="mdc-button__icon mdc-button--trailing-icon" />
  </component>
</template>

<script>
import { MDCRipple } from "@material/ripple";
import { AmIcon } from "../Icon";
import { colorValidator, enumValidator } from "../enumValidator";

export default {
  inheritAttrs: false,
  components: {
    AmIcon
  },
  props: {
    /**
     * Button color ["primary", "positive", "negative", "dark"]
     */
    color: {
      type: String,
      validator: colorValidator,
      default: "primary"
    },
    /**
     * Button type ["contained", "transparent", "text", "outlined"]
     */
    variant: {
      type: String,
      validator: enumValidator(["contained", "transparent", "text", "outlined"]),
      default: "contained"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    /**
     * Sets size button ["default", "large"]
     */
    size: {
      type: String,
      default: "default"
    },
    /**
     * Round button
     */
    round: {
      type: Boolean,
      default: false
    },
    /**
     * Sets full-width button
     */
    fullWidth: {
      type: Boolean,
      default: false
    },
    /**
     * Button as link
     */
    href: {
      type: String,
      default: null
    },
    /**
     * Button leading icon (material icon)
     */
    leadingIcon: {
      type: String,
      default: null
    },
    /**
     * Button trailing icon (material icon)
     */
    trailingIcon: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      mdcRipple: undefined
    };
  },
  computed: {
    classes() {
      return [
        `mdc-button--color-${this.color}`,
        {
          "mdc-button--unelevated": ["contained", "transparent"].indexOf(this.variant) !== -1,
          "mdc-button--outlined": this.variant === "outlined",
          "mdc-button--large": this.size === "large",
          "mdc-button--full-width": this.fullWidth,
          "mdc-button--round": this.round,
          "mdc-button--transparent": this.variant === "transparent",
          "mdc-button--text": this.variant === "text"
        }
      ];
    },
    tag() {
      return this.href ? "a" : "button";
    }
  },
  mounted() {
    this.reInstantiateRipple();
  },
  watch: {
    classes() {
      this.reInstantiateRipple();
    }
  },
  methods: {
    reInstantiateRipple() {
      if (this.mdcRipple) {
        this.mdcRipple.destroy();
      }

      this.mdcRipple = MDCRipple.attachTo(this.$el);
    }
  },
  beforeDestroy() {
    if (this.mdcRipple) {
      this.mdcRipple.destroy();
    }
  }
};
</script>
